getCacheInfo